<template>
   <div class="page-wechat-result">
     <div class="tips"
          v-if="tipsInfo"
     >
       <div class="title">提示信息</div>
       <span>{{ tipsInfo }}</span>
     </div>
   </div>
</template>

<script>
  import { wechatRegister } from '@/services/user';
  import { locationHref } from '@/utils';

  export default {
    name: 'RegisterWechatResult',
    metaInfo: {
      title: '提示信息',
    },
    data() {
      return {
        tipsInfo: '',
        timeout: 0,
        location: '',
      };
    },
    methods: {
      async fetchData() {
        const data = await wechatRegister();
        this.tipsInfo = data.msg;
        this.timeout = data.timeout;
        this.location = data.location;
        setTimeout(() => {
          locationHref(this.location);
        }, this.timeout);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-wechat-result {
    height: 100%;
    background: @color-white;
    padding-top: @size-medium;
  }

  .tips {
    width: 650px;
    margin: 0 auto;
    border: @border-width-base @border-style-base @color-text-lighter;
    padding: @size-small @size-extra-small;
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

  .title {
    font-size: @font-size-medium;
    color: @color-black-dark;
    margin-bottom: @size-extra-small;
  }
</style>
